import React from 'react'
import FeatureMap from '../../elem/map/Map'

const DisclosureOverview = ({ overviewData, loading, isNonOG }) => {
    return (
        <div id="disclosure_content">
            <div className="disclosure_details">
                <p className="disc_title">
                    Disclosure(s) for {overviewData.WellName}
                </p>
                <p className="subtext">
                    Operated by {overviewData.OperatorClean}
                </p>
                {isNonOG ? (
                    <p className="subtext">
                        <strong>PERMIT:</strong> {overviewData.PermitId ?? 'N/A'} &nbsp;&nbsp;&nbsp;&nbsp; API: {overviewData.APINumber}
                    </p>
                    ) : (
                    <p className="subtext">API: {overviewData.APINumber}</p>
                )}
                <table className="welltable" cellSpacing="{0}">
                    <tbody>
                        <tr>
                            {isNonOG && <th>Well Type</th>}
                            <th>State</th>
                            <th>County</th>
                            <th>Indian Well</th>
                            <th>Federal Well</th>
                        </tr>
                        <tr>
                            {isNonOG && <td>{overviewData.WellType ?? 'N/A'}</td>}
                            <td>{overviewData.StateName}</td>
                            <td>{overviewData.CountyName}</td>
                            <td>{overviewData.IndianWell === 'true' ? 'Yes' : 'No'}</td>
                            <td>{overviewData.FederalWell === 'true' ? 'Yes' : 'No'}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="details_map">
                <FeatureMap
                    lat={overviewData.Latitude}
                    lon={overviewData.Longitude}
                    loading={loading}
                />
            </div>
        </div>
    )
}

export default DisclosureOverview
